import "../css/style.scss";
// import "../node_modules/font-awesome/css/font-awesome.min.css";
// modules / classes
import { SiteHeader } from "./modules/SiteHeader";
// import { ContactForm } from "./modules/ContactForm";
var burgerMenu = new SiteHeader();
import { initializeInfiniteScroll } from "./modules/InfinityScroll";
document.addEventListener('DOMContentLoaded', function () {
    initializeInfiniteScroll({
        containerSelector: '#main-content',
        paginationSelector: '#pagination',
        offset: 400, // How far from the bottom to start loading new posts
    });
});
import { initializeCategorySelection } from "./modules/CategorySelection";
initializeCategorySelection();
// const contactForm = new ContactForm();
